<template>
  <div
    :class="pricingClass"
    class="price"
  >
    {{ displayPrice | toPrice }}
  </div>
</template>

<script>
import applogger from '@applogger'

export default {
  name: 'price-element',
  props: {
    price: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayPrice: function() {
      if (typeof this.price === 'string') {
        applogger.error(`PriceElement: Product Price detected as string: ${this.$parent.item.id}`)
        console.log(JSON.stringify(this.$parent.item, null, 2))
      }
      return this.price
    },
    pricingClass: function() {
      if (this.price <= 0) {
        return 'free'
      }
      return ''
    }
  }
}
</script>
